module.exports = __webpack_public_path__ + "img/badge-voucher.8f0f8103.png";